import { FC, Fragment, useContext, useState } from 'react';
import { MoContext } from 'contexts/MoContext';
import { actionTargetsOrder, useOrdersAction } from '../Assistant/ordersActions';
import { OrderLog, OrderRow } from 'ts/shared/interfaces/MOResponse';
import Button from 'components/ui/Button/Button';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { openLog } from 'services/myOrders';
import { MainContext } from 'contexts/MainContext';

interface MoOpenLogsProps {
  orderRow: OrderRow;
  onLoadLogs: (log: OrderLog[]) => void;
}

const MoOpenLogs: FC<MoOpenLogsProps> = ({ orderRow, onLoadLogs }) => {
  const [t] = useTranslation();
  const [loading, setLoading] = useState(false);
  const { user } = useContext(MainContext);
  const { activeOrder } = useContext(MoContext);
  const isActive = activeOrder?.orderRow.segmentId === orderRow.segmentId;

  const openLogs = async () => {
    setLoading(true);
    const res = await openLog({
      orderId: orderRow.orderId,
      segmentId: orderRow.segmentId,
    });
    if (res?.orderLogs) {
      onLoadLogs(res.orderLogs);
    }

    setLoading(false);
  };

  useOrdersAction(
    (action) =>
      action.action === 'open-logs' &&
      actionTargetsOrder(action, { segmentId: orderRow.segmentId, orderId: orderRow.orderId }, isActive),
    () => {
      if (user?.allowOpenLog) void openLogs();
    },
    isActive,
  );

  return (
    <Fragment>
      {user?.allowOpenLog && (
        <Button
          onClick={openLogs}
          title={t(loading ? 'mo.loading' : 'mo.open_log')}
          className="btn btn-primary btn-ssm mb-10"
          disabled={loading}
          icon={faFileLines}
          iconclassname="mr-5"
        />
      )}
    </Fragment>
  );
};

export default MoOpenLogs;
